module.exports = __webpack_public_path__ + "static/back_event_03-c3eea87acf679d09b620af2d78ca9a81.jpg";